module.exports = __webpack_public_path__ + "img/farizon-borges.71857db8.jpg";